const competitiveSites = {
  competitiveSites: [
    {
      siteName: "GitHub",
      iconifyClassname: "simple-icons:github",
      style: {
        color: "black",
      },
      profileLink: "https://github.com/gopalgoyal2002",
    },
    {
      siteName: "LinkedIn",
      iconifyClassname: "simple-icons:linkedin",
      style: {
        color: "black",
      },
      profileLink: "https://www.linkedin.com/in/gopal-goyal-863981175/",
    },
    {
      siteName: "LeetCode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "black",
      },
      profileLink: "https://leetcode.com/gopalgoyal612002/",
    },
    {
      siteName: "InterviewBit",
      iconifyClassname: "simple-icons:InterviewBit",
      style: {
        color: "black",
      },
      profileLink: "https://www.interviewbit.com/profile/gopal-goyal_990",
    },
  ],
};

const projects = {
  projects: [
    {
      Title: "Agentic RAG System",
      Desription: {
        desc: [
          "Agentic RAG with multi-step reasoning and tool use.",
          "MCP tools for SQL/Mongo/Weaviate, Cohere + BGE retrieval, served via FastAPI on AWS ECS.",
        ],
      },
      github: "https://github.com/gopalgoyal2002",
      live: "https://github.com/gopalgoyal2002",
    },
    {
      Title: "Resume Parser & JD Matcher",
      Desription: {
        desc: [
          "spaCy NER extracts name, email, phone, and skills from resumes.",
          "Ranks resumes against a job description by semantic similarity — Django app.",
        ],
      },
      github: "https://github.com/gopalgoyal2002/Resume-Filter",
      live: "https://github.com/gopalgoyal2002/Resume-Filter",
    },
    {
      Title: "Contradiction & Entailment (NLP)",
      Desription: {
        desc: [
          "BERT + ANN model classifying sentence-pair relationships.",
          "Reached 92.85% accuracy on a large sentence-pair dataset.",
        ],
      },
      github: "https://github.com/gopalgoyal2002",
      live: "https://github.com/gopalgoyal2002",
    },
    {
      Title: "E-Commerce App (MERN)",
      Desription: {
        desc: [
          "Full MERN store with an admin panel.",
          "Auth, cart, and product CRUD APIs across React, Node, Express, and MongoDB.",
        ],
      },
      github: "https://github.com/gopalgoyal2002/Website-for-selling-book-in-MERN-Stack",
      live: "https://github.com/gopalgoyal2002/Website-for-selling-book-in-MERN-Stack",
    },
    {
      Title: "Book Recommendation System",
      Desription: {
        desc: [
          "KNN recommender on user-rating data.",
          "Interactive Streamlit UI, deployed to the cloud.",
        ],
      },
      github: "https://github.com/gopalgoyal2002/Book_Recommendation_System",
      live: "https://github.com/gopalgoyal2002/Book_Recommendation_System",
    },
    {
      Title: "One-Class Text Classification",
      Desription: {
        desc: [
          "Binary text classification from a single training class.",
          "Solved with model ensembles based on a research paper.",
        ],
      },
      github: "https://github.com/gopalgoyal2002/One_Class_Text_Classification",
      live: "https://github.com/gopalgoyal2002/One_Class_Text_Classification",
    },
    {
      Title: "Blog Web App",
      Desription: {
        desc: [
          "Full-stack blogging app with a complete authoring flow.",
          "React frontend with a Node.js + MongoDB backend.",
        ],
      },
      github: "https://github.com/gopalgoyal2002/Blog-Web-App",
      live: "https://github.com/gopalgoyal2002/Blog-Web-App",
    },
    {
      Title: "Developer Portfolio",
      Desription: {
        desc: [
          "This site — a React portfolio with SEO baked in.",
          "Clean, responsive, animation-light design.",
        ],
      },
      github: "https://github.com/gopalgoyal2002/Portfolio-React",
      live: "https://gopalgoyal.in",
    },
  ],
};

const experience = {
  experience: [
    {
      componyName: "HiRobin",
      time: "Feb 2026 – Present",
      desc: {
        description: [
          "Building the backend of an AI voice-agent platform — 50K+ daily users, 5M+ calls.",
          "Shipped inbound/outbound calling, scheduling, and notification workflows.",
          "Integrated realtime models and LiveKit for streaming speech.",
          "Own deployments, migrations, and performance tuning in production.",
        ],
      },
      link: "https://hirobin.ai",
      Designation: "Founding Engineer",
    },
    {
      componyName: "Zeon AI",
      time: "Sep 2023 – Feb 2026",
      desc: {
        description: [
          "Grew from SDE 1 to SDE 3 / Lead Developer over 2.5 years.",
          "Built an agentic RAG system with reasoning and tool use; MCP integrations for SQL, MongoDB, and Weaviate.",
          "Created ASK AI, an agentic assistant for enterprise data analysis (InvoiceAI).",
          "Automated end-to-end invoice posting with ERP integration on a serverless Python backend.",
          "Fine-tuned DONUT (VQA), SetFit, and Zephyr-Gemma (DPO); deployed LLMs on AWS SageMaker.",
        ],
      },
      link: "https://www.zeonai.com/",
      Designation: "SDE 1 → SDE 3 (Lead Developer)",
    },
    {
      componyName: "ANZ",
      time: "Jun 2023 – Sep 2023",
      desc: {
        description: [
          "Automated testing for trading-platform components using Java Cucumber.",
        ],
      },
      link: "https://www.anz.com/",
      Designation: "Graduate Engineer",
    },
    {
      componyName: "Upwork",
      time: "Feb 2023 – May 2023",
      desc: {
        description: [
          "Delivered 8 client projects with a 5-star rating.",
          "Built React/Node/FastAPI apps and Streamlit dashboards on AWS and Azure.",
        ],
      },
      link: "https://www.upwork.com/freelancers/~0117d3589c5f9cebdb",
      Designation: "Freelance Developer",
    },
    {
      componyName: "Aryma Labs",
      time: "Jan 2023",
      desc: {
        description: [
          "Built a spaCy NER model to extract names from resumes.",
          "Automated email-attachment collection with Python.",
        ],
      },
      link: "https://www.arymalabs.com/",
      Designation: "NLP Intern",
    },
    {
      componyName: "Zeon AI Labs",
      time: "Mar 2022 – Nov 2022",
      desc: {
        description: [
          "Built a document-retrieval pipeline over ElasticSearch and Pinecone; benchmarked against Milvus.",
          "Shipped AWS Lambda jobs for SQL→SQS chunking and Twitter sentiment to DynamoDB.",
          "Built tag auto-completion and CRUD APIs with FastAPI.",
        ],
      },
      link: "https://www.zeonai.com/",
      Designation: "Data Science Intern",
    },
    {
      componyName: "Edunomics Tech Solutions",
      time: "Dec 2021 – Jan 2022",
      desc: {
        description: [
          "Built React data tables wired to SQL queries for a client site.",
          "Developed web pages with SiteJet and fixed bugs across the stack.",
        ],
      },
      link: "https://techedunomics.netlify.app/",
      Designation: "Software Engineer Intern",
    },
  ],
};

const skills = {
  programming_skills: [
    { path: "", name: "C++" },
    { path: "", name: "Python" },
    { path: "", name: "JavaScript" },
  ],
  web_skills: [
    { path: "", name: "ReactJS" },
    { path: "", name: "Node.js" },
    { path: "", name: "FastAPI" },
  ],
  cloud_skills: [
    { path: "", name: "AWS" },
    { path: "", name: "S3" },
    { path: "", name: "Lambda" },
    { path: "", name: "EC2" },
    { path: "", name: "DynamoDB" },
    { path: "", name: "SQS" },
    { path: "", name: "Docker" },
  ],
  backend_skills: [
    { path: "", name: "SQL" },
    { path: "", name: "MongoDB" },
    { path: "", name: "BigQuery" },
    { path: "", name: "ElasticSearch" },
    { path: "", name: "Pinecone" },
  ],
  ml_skills: [
    { path: "", name: "LLMs" },
    { path: "", name: "NLP" },
    { path: "", name: "Agentic AI / RAG" },
    { path: "", name: "LangGraph" },
    { path: "", name: "Hugging Face" },
    { path: "", name: "Fine-tuning (LoRA/DPO)" },
    { path: "", name: "OpenAI" },
    { path: "", name: "Scikit-learn" },
    { path: "", name: "TensorFlow" },
  ],
};

const openSourceData = {
  openSourceData: [
    {
      Path: "images/Golem Networks.png",
      componyName: "Golem Networks",
      weblink: "https://www.golem.network/",
      maingithub: "https://github.com/gopalgoyal2002/golem-js-preview-program",
      repolink: "https://github.com/gopalgoyal2002/golem-js-preview-program",
      heading: "Contributed to the review program and raised issues for the golem-js preview.",
      add: 0,
      subtract: 0,
    },
  ],
};

export { competitiveSites, projects, experience, skills, openSourceData };
